export interface PendingTaskBoard {
    Name?: string;
    ProjectId?: number;
    Project?: string;
    Description?: string;
    Color?: string;
}

export interface PendingDeleteTaskBoard {
    awaitingName?: boolean;
}

export const startCreateTaskBoardFlow = (
    setPendingTaskBoard: (data: PendingTaskBoard | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void,
    nameFromIntent?: string
) => {
    if (nameFromIntent) {
        setPendingTaskBoard({ Name: nameFromIntent });

        pushAIChat(`Great! Which project should "${nameFromIntent}" belong to?`);
        speak(`Which project should ${nameFromIntent} belong to?`);
        return;
    }

    setPendingTaskBoard({});
    pushAIChat("Sure! What should the task board be called?");
    speak("What should the task board be called?");
};

export const processPendingTaskBoard = (
    text: string,
    pending: PendingTaskBoard,
    setPendingTaskBoard: (data: PendingTaskBoard | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {

    // STEP 1 — Board Name
    if (!pending.Name) {
        const cleanName = text.replace(/[^a-zA-Z0-9 ]/g, "").trim();

        if (!cleanName) {
            pushAIChat("Please provide a valid board name.");
            speak("Please provide a valid board name.");
            return;
        }

        setPendingTaskBoard({ ...pending, Name: cleanName });

        pushAIChat(`Which project should "${cleanName}" belong to?`);
        speak(`Which project should ${cleanName} belong to?`);

        // ✅ SHOW PROJECT SUGGESTIONS
        window.dispatchEvent(
            new CustomEvent("ai-suggest-options", {
                detail: { type: "project" }
            })
        );
        return;
    }

    // STEP 2 — Project (REQUIRED)
    if (!pending.Project) {
        const project = text.trim();

        if (!project) {
            pushAIChat("Please select a valid project.");
            speak("Please select a valid project.");
            return;
        }

        setPendingTaskBoard({ ...pending, Project: project });

        pushAIChat("Would you like to add a description?");
        speak("Would you like to add a description?");
        return;
    }

    // STEP 3 — Description (OPTIONAL)
    if (!pending.Description) {
        setPendingTaskBoard({ ...pending, Description: text });

        pushAIChat("Do you want to choose a board color?");
        speak("Do you want to choose a board color?");
        return;
    }

    // STEP 4 — Color (OPTIONAL)
    if (!pending.Color) {
        const color = text.startsWith("#") ? text : "#dc3545";

        const finalData = {
            ...pending,
            Name: pending.Name,
            Project: pending.ProjectId,
            Color: color,
            Status: "active"
        };

        pushAIChat(`Perfect! Creating task board "${pending.Name}"...`);
        speak(`Creating task board ${pending.Name}.`);

        window.dispatchEvent(
            new CustomEvent("ai-create-task-board", {
                detail: finalData
            })
        );

        setPendingTaskBoard(null);
    }
};

export const startDeleteTaskBoardFlow = (
    setPendingDelete: (data: PendingDeleteTaskBoard | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void,
    nameFromIntent?: string
) => {
    if (nameFromIntent) {
        pushAIChat(`Deleting task board "${nameFromIntent}"...`);
        speak(`Deleting task board ${nameFromIntent}`);

        window.dispatchEvent(
            new CustomEvent("ai-delete-task-board", {
                detail: { name: nameFromIntent }
            })
        );
        return;
    }

    setPendingDelete({ awaitingName: true });
    pushAIChat("Which task board would you like to delete?");
    speak("Which task board would you like to delete?");
};

//process delete taskboardflow
export const processPendingDeleteTaskBoard = (
    text: string,
    pending: PendingDeleteTaskBoard,
    setPendingDelete: (data: PendingDeleteTaskBoard | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {
    if (!pending.awaitingName) return;

    const cleanName = text.replace(/[^a-zA-Z0-9 ]/g, "").trim();

    if (!cleanName) {
        pushAIChat("Please provide a valid task board name to delete.");
        speak("Please provide a valid task board name.");
        return;
    }

    pushAIChat(`Deleting task board "${cleanName}"...`);
    speak(`Deleting task board ${cleanName}.`);

    window.dispatchEvent(
        new CustomEvent("ai-delete-task-board", {
            detail: { name: cleanName }
        })
    );

    setPendingDelete(null);
};

